<div class="eos-table-flag-renderer-container">
  <mat-icon slot="icon" ngClass="{{flag | flagClass}}">{{flag | flagIcon}}</mat-icon>
</div>
